
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, MapPin } from "lucide-react";
import { HomeStats } from "@/hooks/useHomeStats";

interface WorkerStatsSectionProps {
  homeStats: HomeStats;
  statsLoading: boolean;
}

export const WorkerStatsSection: React.FC<WorkerStatsSectionProps> = ({
  homeStats,
  statsLoading
}) => {
  if (statsLoading) {
    return (
      <section className="mb-6">
        <div className="grid grid-cols-2 gap-4">
          <Card>
            <CardContent className="flex items-center p-4">
              <div className="animate-pulse flex space-x-4 w-full">
                <div className="rounded-full bg-gray-200 h-10 w-10"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-6 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="flex items-center p-4">
              <div className="animate-pulse flex space-x-4 w-full">
                <div className="rounded-full bg-gray-200 h-10 w-10"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-6 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    );
  }

  return (
    <section className="mb-6">
      <div className="grid grid-cols-2 gap-4">
        <Card>
          <CardContent className="flex items-center p-4">
            <div className="flex items-center space-x-4 w-full">
              <div className="p-2 bg-blue-100 rounded-full">
                <Users className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-600">Ouvriers assignés</p>
                <p className="text-2xl font-bold text-[#333333]">{homeStats.employesActifs}</p>
              </div>
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardContent className="flex items-center p-4">
            <div className="flex items-center space-x-4 w-full">
              <div className="p-2 bg-green-100 rounded-full">
                <MapPin className="h-6 w-6 text-green-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-600">Chantiers actifs</p>
                <p className="text-2xl font-bold text-[#333333]">{homeStats.chantiersActifs}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
